import { render } from "./clickable-list.vue?vue&type=template&id=6dace505"
import script from "./clickable-list.vue?vue&type=script&lang=js"
export * from "./clickable-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__